import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({children, show = false, ...rest}) => show && <div className="overlay" {...rest}>{children}</div>;

Overlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ])
};

export default Overlay;


// WEBPACK FOOTER //
// ./src/components/layout/overlay.jsx